import React from "react";
import { Redirect } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ChangePwd from "../pages/Authentication/ChangePassword";
import Changepassword from "../pages/ChangePassword/ChangePassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// User Management 
import UserManagement from "../pages/UserManagement/";
import Add_user from "../pages/UserManagement/Add_user";
import Edit_user from "../pages/UserManagement/Edit_user";
import UserWallet from "../pages/UserManagement/UserWallet";
import Portfolio from "../pages/UserManagement/Portfolio";

//Collaborator Management 
import CollaboratorManagement from "../pages/CollaboratorManagement/";
import CollaboratorDetails from "../pages/CollaboratorManagement/Collaborator_Details";

// General Settings
import GeneralSettings from "../pages/SiteSettings/index";
import SemSettings from "../pages/SiteSettings/SemSettings";
import Emailformat from "../pages/SiteSettings/Emailformat";
import WithdrawalSettings from "../pages/SiteSettings/Withdrawal";
import BankDetails from "../pages/SiteSettings/BankDetails";
import MailChimp from "../pages/SiteSettings/MailChimp";

// Transaction 
import Transaction from "../pages/Transaction/index";

// User KYC 
import UserKYC from "../pages/UserKYC/index";

// Claim Fund 
import ClaimFund from "../pages/ClaimFund/index";
import ClaimFundDetails from "../pages/ClaimFund/details";

// Withdrawal Request 
import WithdrawalRequest from "../pages/WithdrawalRequest/index";

// Dividends 
import Dividends from "../pages/Dividends/index";
import DividendTransactions from "../pages/Dividends/DividendTransactions";

// Referral Reward 
import ReferralReward from "../pages/ReferralReward/index";
import Referral from "../pages/ReferralReward/referral";

// Welcome Bonus 
import WelcomeBonus from "../pages/WelcomeBonus";

// Transaction 
import Property from "../pages/Property/index";
import Edit_Property from "../pages/Property/Edit_Property";
import Property_Documents from "../pages/Property/Property_Documents";
import Team from "../pages/Property/Team";

//Report
import UsersReport from "../pages/Report/users";
import TransactionsReport from "../pages/Report/transactions";

const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/profile", exact: true, component: UserProfile },
  { path: "/changepassword", exact: true, component: Changepassword },

  // User Management 
  { path: "/user_management", component: UserManagement },
  { path: "/add_user", component: Add_user },
  { path: "/edit_user", component: Edit_user },
  { path: "/edit_user/:id", component: Edit_user },
  { path: "/user_wallet", component: UserWallet },
  { path: "/user_wallet/:id", component: UserWallet },
  { path: "/portfolio", component: Portfolio },
  { path: "/portfolio/:id", component: Portfolio },

  // User Management 
  { path: "/collaborators", component: CollaboratorManagement },
  { path: "/collaborator-details/:id", component: CollaboratorDetails },

  // General Management 
  { path: "/general_settings", component: GeneralSettings },
  { path: "/sem_settings", component: SemSettings },
  { path: "/email_format", component: Emailformat },
  { path: "/withdrawal_settings", component: WithdrawalSettings },
  { path: "/bank-details", component: BankDetails },
  { path: "/sync-mailchimp", component: MailChimp },

  // Transaction 
  { path: "/transaction", component: Transaction },
  { path: "/transaction/:id", component: Transaction },

  // User KYC 
  { path: "/user_kyc", component: UserKYC },
  { path: "/user_kyc/:id", component: UserKYC },

  // Property 
  { path: "/property", component: Property },
  { path: "/edit_property", component: Edit_Property },
  { path: "/edit_property/:id", component: Edit_Property },
  { path: "/property_documents/:id", component: Property_Documents },
  { path: "/team/:id", component: Team },

  // Claim Fund 
  { path: "/claim_fund", component: ClaimFund },
  { path: "/claim_fund/:id", component: ClaimFund },
  { path: "/claim_fund_details", component: ClaimFundDetails },

  // Withdrawal Request 
  { path: "/withdrawal_request", component: WithdrawalRequest },
  { path: "/withdrawal_request/:id", component: WithdrawalRequest },

  // Dividends 
  { path: "/dividends", component: Dividends },
  { path: "/dividends_transactions", component: DividendTransactions },
  { path: "/dividends_transactions/:id", component: DividendTransactions },

  // Referral Reward 
  { path: "/referral_reward", component: ReferralReward },
  { path: "/referral_reward/:id", component: ReferralReward },
  { path: "/referral", component: Referral },
  { path: "/referral/:id", component: Referral },

  // Welcome Bonus 
  { path: "/welcome_bonus", component: WelcomeBonus },
  

  { path: "/", exact: true, component: () => <Redirect to="/login" /> },

  //Report
  { path: "/users_report", component: UsersReport },
  { path: "/transactions_report", component: TransactionsReport },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/change-password", component: ChangePwd },
];

export { authProtectedRoutes, publicRoutes };
